export default __webpack_public_path__ + "static/media/scrollbar_increment_light.3aa3faff.svg";